import axios from "axios";
var base64 = require('base-64');
var md5 = require('md5');
import config from "config/index";
let host = config.host+"/api/"
let apikey=config.apikey
// initializing the axios instance with custom configs
const verifyCode = function (mobileNumber,code) {
    return axios.post(host + `Authentication/Verify`,
        {
            "mobileNumber": mobileNumber,
            "code": code,
            "deviceName": "galaxy s5"
        },
        {
            headers: {
                "Content-Type": "application/json",
                "ApiKey": apikey
            }
        }).then((response) => {
            return response.data
        })
}


export default verifyCode